import { AbstractBlock } from '../AbstractBlock';
import { ColorSettings } from '../setting/ColorSettings';
import { ShapeSettings } from '../setting/ShapeSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const Blockly = GlobalImport.getBlockly();

const t = block_translation;
export class ARBarcodeAttribute extends AbstractBlock {
  defineBlock(block: BlockType): void {
    ShapeSettings.setAttributeShape(block);
    ColorSettings.setARColor(block);

    ShapeSettings.setTitleField(block, this.title);

    const barcodeValue = new Blockly.FieldTextInput('0');
    block
      .appendDummyInput()
      .appendField(t.to('値(0-63)', 'marker_value0_63'))
      .appendField(barcodeValue, 'value');

    ShapeSettings.addAttributeInput(block);
  }

  codeGenerateCore(block: BlockType): string[] {
    const value = CodeSetting.getFieldValue(block, 'value');
    const attribute = CodeSetting.getSubAttributeCode(block);
    // let str = " type = 'barcode' value = '" + value + "' " + attribute ;

    const str = CodeSetting.buildAttribute(
      [
        ['type', 'barcode'],
        ['value', value],
      ],
      attribute
    );
    return [str];
  }
}
